import { render } from "./ExtDocList.vue?vue&type=template&id=6040209c"
import script from "./ExtDocList.vue?vue&type=script&lang=js"
export * from "./ExtDocList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/ExtDoc/ExtDocList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6040209c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6040209c', __exports__)) {
    console.log('reload')
    api.reload('6040209c', __exports__)
  }
  
  module.hot.accept("./ExtDocList.vue?vue&type=template&id=6040209c", () => {
    console.log('re-render')
    api.rerender('6040209c', render)
  })

}


export default __exports__